import config from 'config';
import Manager from './manager';

const AUTH_CLUB = 'club';
const AUTH_TOKEN_KEY = 'auth';

class Auth {
  _logged = false;

  constructor(networkLayer) {
    this._networkLayer = networkLayer;
    this._logPromise = Promise.resolve();
  }

  get loggedIn() {
    return this._logged;
  }

  get logPromise() {
    return this._logPromise;
  }

  login(userName, password) {
    return this._networkLayer.postJson(`${config.backOfficeBasePath}/auth/login`, {
      user_name: userName,
      password
    })
      .then((data) => {
        this._logged = true;
        sessionStorage.setItem(AUTH_TOKEN_KEY, data.token);
        return data
      });
  }

  logout() {
    return Promise.resolve()
      .then((data) => {
        this._logged = false;
        sessionStorage.removeItem(AUTH_TOKEN_KEY);
        sessionStorage.removeItem(AUTH_CLUB);
        return data
      });
  }

  restore() {
    return this._logPromise = this._networkLayer.getJson(`${config.backOfficeBasePath}/auth/me`)
      .then((data) => {
        this._logged = true;
        sessionStorage.setItem(AUTH_CLUB, JSON.stringify(data.club));
        return new Manager(data);
      });
  }

  forgotPassword(email) {
    return this._networkLayer.postJson('api/restore_password', {
      email
    });
  }

  updatePassword(password, updateToken) {
    return this._networkLayer.postJson(`${config.backOfficeBasePath}/auth/update-password`, {
      update_token: updateToken,
      password
    })
      .then((data) => {
        this._logged = true;
        return data
      });
  }

  checkUpdatePasswordToken(updateToken) {
    return this._networkLayer.getJson(`${config.backOfficeBasePath}/auth/update-password`, {
      update_token: updateToken
    });
  }

  async checkConfirmToken(token) {
    try {
      let res = await this._networkLayer.post(`${config.backOfficeBasePath}/managers/confirm/${token}`);
      return res.status === 200;
    }
    catch (e) {
      return false;
    }
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/auth.js